export const LOCATION_CATEGORIES = Object.freeze({
  ALL: 'All Locations',
  MEMBER: "Member's Location",
  APPROVED: 'Approved Locations',
});
